<template>
  <div class="container">
    <div class="title">{{ name }}小程序隐私保护说明</div>
    <div>
      本指引是{{
        name
      }}小程序开发者（以下简称“开发者”）为处理你的个人信息而制定。
    </div>
    <div>1. 开发者处理的信息</div>
    <div>根据法律规定，开发者仅处理实现小程序功能所必要的信息。</div>
    <div>
      为了注册、登录小程序，开发者收集你的用户信息（微信昵称、头像、性别、地区）。
      开发者收集你的手机号码，微信号，姓名用于名片信息展示。
    </div>
    <div>2. 你的权益</div>
    <div>
      开发者承诺，除法律法规另有规定外，开发者对你的信息的保存期限应当为实现处理目的所必要的最短时间。
    </div>
    <div>
      关于{{
        name
      }}，你可以通过以下路径：小程序主页右上角“…”—“设置”—点击特定信息—点击“不允许”，撤回对开发者的授权。
    </div>
    <div>
      关于你的个人信息，你可以通过以下方式与开发者联系，行使查阅、复制、更正、删除等法定权利。
    </div>
    <div>邮箱： hyy@alighting.cn</div>
    <div>4. 信息的使用规则</div>
    <div>开发者将会在本指引所明示的用途内使用收集的信息</div>
    <div>
      如开发者使用你的信息超出本指引目的或合理范围，开发者必须在变更使用目的或范围前，再次以{{
        name
      }}方式告知并征得你的明示同意。
    </div>
    <div>5. 信息对外提供</div>
    <div>
      开发者承诺，不会主动共享或转让你的信息至任何第三方，如存在确需共享或转让时，开发者应当直接征得或确认第三方征得你的单独同意。
    </div>
    <div>
      开发者承诺，不会对外公开披露你的信息，如必须公开披露时，开发者应当向你告知公开披露的目的、披露信息的类型及可能涉及的信息，并征得你的单独同意。
    </div>
    <div>
      你认为开发者未遵守上述约定，或有其他的投诉建议、或未成年人个人信息保护相关问题，可通过以下方式与开发者联系；或者向微信进行投诉。
    </div>
    <div>邮箱： kaci@alighting.cn</div>
    <div style="margin-top: 50px">
      <div class="text">更新日期：2020-06-01</div>
      <div class="text">生效日期：2020-06-01</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "protocol",
  data() {
    return {
      name: "",
    };
  },
  mounted() {
    this.name = decodeURIComponent(this.$route.query.name);
  },
};
</script>
<style scoped lang="less">
.container {
  padding: 20px;
  font-size: 14px;
  .title {
    text-align: center;
    font-size: 18px;
  }
  div {
    margin-bottom: 10px;
    text-align: justify;
  }
  .text {
    text-align: right !important;
  }
}
</style>